module.exports = __webpack_public_path__ + "img/202307_01_sp.a7832e7f.jpg";